module.exports = __webpack_public_path__ + "static/media/empty-list@2x.8120db18.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/empty-list@2x.png
// module id = 1027
// module chunks = 0